import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { FeedbackTopicGet } from "../../../models/FeedbackTopic"
import { useHashTab } from "../../../../hooks/useHashTab"
import { FeedbackTopicDetails } from "./details_tab/FeedbackTopicDetails"

const returnURL = "/feedbacks#topics"

export function FeedbackTopicContainer() {
  const { feedbackTopicId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [feedbackTopic, setFeedbackTopic] = useState<FeedbackTopicGet>()

  useEffect(() => {
    if (feedbackTopicId) {
      digitalManagerApi
        .get<FeedbackTopicGet>(`/feedbackTopics/${feedbackTopicId}`)
        .then((res) => {
          setFeedbackTopic(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, feedbackTopicId])

  if (!feedbackTopicId) {
    return <Navigate to={returnURL} />
  }

  if (!feedbackTopic) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: feedbackTopic.name,
    label: "Feedback topic ID",
    subtitle: feedbackTopic.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <FeedbackTopicDetails
          feedbackTopic={feedbackTopic}
          setFeedbackTopic={setFeedbackTopic}
        />
      )}
    </div>
  )
}
